export const petsWithAddresses = [
  {
    id: 'pet-001',
    name: 'Max',
    ownerId: 'user-001',
    address: 'Calle 123 #45-67, Bogotá',
    coordinates: { lat: 4.710989, lng: -74.072092 },
    image: 'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=200'
  },
  {
    id: 'pet-002',
    name: 'Luna',
    ownerId: 'user-002',
    address: 'Carrera 89 #12-34, Bogotá',
    coordinates: { lat: 4.698214, lng: -74.056326 },
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=200'
  }
];

export const drivers = [
  { id: 'driver-001', name: 'Carlos Transporte', vehicle: 'ABC123' },
  { id: 'driver-002', name: 'Ana Movilidad', vehicle: 'XYZ789' }
];

export const routes = [
  {
    id: 'route-001',
    date: '2023-06-15',
    driverId: 'driver-001',
    type: 'morning',
    stops: [
      {
        petId: 'pet-001',
        action: 'pickup',
        scheduledTime: '07:30',
        status: 'pending',
        actualTime: null
      },
      {
        petId: 'pet-002',
        action: 'pickup',
        scheduledTime: '07:45',
        status: 'pending',
        actualTime: null
      }
    ]
  }
];

export const routeHistory = [
  {
    id: 'hist-001',
    routeId: 'route-001',
    date: '2023-06-14',
    driverId: 'driver-001',
    completed: true,
    stopsCompleted: 4
  }
];